// utils
import axios from '../../utils/axios';

const addUserToOrg = async (data, orgId) => {
  try {
    // const userId = localStorage.getItem('_id');
    const response = await axios({
      method: 'put',
      url: `/organizations/${orgId}/user`,
      data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { addUserToOrg };
